import { styled } from '@mui/material/styles';
import { COLORS } from '../../../../utils/colors';
import { Box } from '@mui/material';
import { Modal, Tabs } from '@mui/material';

export const useAvailabilitySettingsStyles = () => {
  return {
    saveButton: {
      position: 'absolute',
      right: '2rem',
      top: '1.5rem',
      display: 'flex',
      paddingLeft: '2rem',
      paddingRight: '2rem',
      backgroundColor: COLORS.PRIMARY,
      borderRadius: '2rem',
      color: '#fff !important',
      height: '2rem',
      '&: hover': {
        backgroundColor: COLORS.MEDIUM_GRAY,
      },
    },
  };
};

export const StyledOverlay = styled(Modal)({
  '& .MuiModal-backdrop': {
    //background: 'transparent',
  },
});

export const StyledModal = styled(Box)({
  position: 'absolute',
  top: '3.625rem',
  right: 0,
  maxHeight: 'calc(100% - 5rem)',
  minHeight: '60%',
  width: '55%',
  backgroundColor: COLORS.WHITE,
  boxShadow: '0 .125rem .75rem 0 rgba(0, 0, 0, 0.26)',
  padding: '1rem 1.5rem',
  overflowY: 'auto',
});

export const CustomTabs = styled(Tabs)({
  '.MuiTab-root.Mui-selected': {
    color: COLORS.VHC_GRAY,
  },
  '& .MuiTabs-indicator': {
    backgroundColor: `${COLORS.VHC_GRAY} !important`,
  },
  '& .MuiTab-root': {
    color: COLORS.VHC_GRAY,
    paddingTop: '0px',
    paddingBottom: '0px',
    height: '2rem',
  },
});
